<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-08-02 13:27:25
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 09:47:48
 -->
<!--  -->
<template>
  <div id="index">
    <!-- banner -->
    <el-row class="banner_bg">
      <!-- <el-col :span="24"></el-col> -->
      <el-carousel height="220px">
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <img :src="item" alt="" width="100%" style="height:220px" />
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <!-- content -->
    <div class="system_index">
      <el-row class="index_content">
        <el-col :span="24" class="content-card">
          <!-- <img src="/base/images/index/title.png" class="title_img" />
          <span class="work_time">
            亲爱的，这是您在智隆工作的
            <span>1000</span>天
          </span> -->
          <div class="content-card-top">
            <span>
              亲爱的，这是您在智隆工作的
              <span class="work-day">{{ this.zzts }}</span>天
            </span>
          </div>
          <div class="content-card-bottom">
            <el-row>
              <el-col :span="8" class="bottom-left">
                <div class="time-xq">{{ this.nowWeek }}</div>
                <div class="time-rq">{{ this.nowDate }}</div>
              </el-col>
              <el-col :span="1" class="bottom-center"></el-col>
              <el-col :span="15" class="bottom-right">
                <div class="richeng">
                  <span> 日程 </span>
                </div>
                <div class="richeng">
                  <ul>
                    <li>
                      <span class="richeng-bt"> 活动 </span>
                      <span class="richeng-fjx"> </span>
                      <span> 户外素质拓展 </span>
                      <span> 14:30 </span>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="24" class="common_part part_1">
          <!-- <p class="dark_gray_font shortcut_function">快捷功能</p>
          <el-col :span="24" class="shortcut_function_div">
            <template v-if="shortcutFunctionList.length!=0">
              <a
                class="fast_function"
                v-for="(item,index) in shortcutFunctionList "
                :key="index"
                @click="goToFWXQ(item)"
              >
                <img :src="item.src" class="fast_function_img" type="image/svg+xml" width="24" />
                <p>{{item.appName}}</p>
              </a>
            </template>
          </el-col> -->

          <el-col :span="12">
            <!-- <el-col :span="24" class="common_title">
              <img src="/base/images/index/xw_icon.png" />单位新闻
            </el-col> -->
            <el-col :span="24" style="padding-top: 20px; padding-left: 0">
              <el-carousel :interval="5000" arrow="always" indicator-position="none" height="320px"
                style="margin-top: 0px">
                <el-carousel-item v-for="item in carousel" :key="item" :class="carouselHide">
                  <img height="320px" :src="item.src" alt style="width: 100%; height: 100%; border-radius: 6px"
                    @click="goToview(item)" />
                  <h3 class="carousel_title" @click="goToview(item)">
                    {{ item.title }}
                  </h3>
                </el-carousel-item>
              </el-carousel>
              <div class="cLoading" v-loading="carouselLoading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
            </el-col>
          </el-col>
          <el-col :span="12">
            <!-- <el-col :span="24" class="common_title">
              <img src="/base/images/index/xw_icon.png" />通知公告
            </el-col>-->
            <el-col :span="24" class="notice_table">
              <el-row>
                <template v-if="noticeType.length != 0">
                  <el-tabs v-model="latestMsg.activeName" @tab-click="handleClick">
                    <el-tab-pane v-for="(item, index) in noticeType" :key="index" :label="item.label"
                      :name="item.value">
                      <template v-if="noticeType.length != 0">
                        <el-table @row-click="goToview" :loading="latestMsg.loading" :data="latestMsg.data"
                          :show-header="false" height="260" style="
                            width: 100%;
                            font-size: 14px;
                            overflow-y: hidden;
                          ">
                          <el-table-column>
                            <template slot-scope="scope">
                              <div class="todo-item" :title="scope.row.title">
                                {{ scope.row.title }}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column width="170px">
                            <template slot-scope="scope">
                              <div class="todo-item" style="text-align: right">
                                {{ scope.row.publish_time }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                        <span class="seeMore" @click="goToMore(item.value)">查看更多>></span>
                      </template>
                      <template v-else>
                        <p>暂无数据</p>
                      </template>
                    </el-tab-pane>
                  </el-tabs>
                  <!-- <span class="seeMore" @click="goToMore(item.value)">查看更多>></span> -->
                </template>
                <template v-else>
                  <div style="text-align: center; color: #999; padding-top: 16%">
                    <img src="/base/images/index/nodata.png" width="100px" alt />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-row>
            </el-col>
          </el-col>
        </el-col>

        <el-row :span="24" class="el-row-list" :class="lastListHide">
          <el-col :span="24" class="common_title pull-right">
            <img src="/base/images/index/zxfb_icon.png" />
            最新服务
            <span @click="goToFw" class="goToFw" :class="fwlbHide">更多<i class="el-icon-arrow-right"></i></span>
          </el-col>
          <el-col :span="24" class="common_part expressLane_content_div pull-right" v-loading="loadinglastList"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <template v-if="lastList.length != 0">
              <el-col :span="6" v-for="(item, index) in lastList" :key="index">
                <div class="text-center expressLane_content_xt" @click="goToFWXQ(item)">
                  <img :src="item.src" alt class="expressLane_img" />
                  <p>{{ item.appName }}</p>
                </div>
              </el-col>
            </template>
          </el-col>
        </el-row>
        <el-row v-if="textConfig.role != 'stuRole'" class="el-row-list" :class="xtdhHide">
          <el-col :span="24" class="common_title">
            <img src="/base/images/index/xtdh_icon.png" />
            系统导航
            <span>
              <span class="right_icon" @click="nextList()" :class="right_icon_disabled"></span>
              <span class="left_icon_disabled" @click="prevList()" :class="left_icon"></span>
            </span>
          </el-col>
          <el-col :span="24" class="common_part expressLane_content_div" v-loading="loadingList"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <template v-if="list.length != 0">
              <el-col :span="6" v-for="(item, index) in list" :key="index">
                <div class="text-center expressLane_content_xt" @click="goToFWXQ(item)">
                  <img :src="item.src" alt class="expressLane_img" />
                  <p>{{ item.appName }}</p>
                </div>
              </el-col>
            </template>
          </el-col>
        </el-row>
        <el-row v-if="textConfig.role != 'stuRole'" class="el-row-list" :class="glkztHide">
          <el-col :span="24" class="common_title">
            <img src="/base/images/index/glkzt_icon.png" />
            管理控制台
          </el-col>
          <el-col :span="24" class="common_part">
            <el-col :span="24" class="expressLane_content_div" v-loading="loadingglkztList" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading">
              <template v-if="glkztList.length != 0">
                <el-col :span="6" v-for="(item, index) in glkztList" :key="index">
                  <div class="text-center expressLane_content_xt" @click="goToFWXQ(item)">
                    <img :src="item.src" alt class="expressLane_img" />
                    <p>{{ item.appName }}</p>
                  </div>
                </el-col>
              </template>
            </el-col>
          </el-col>
        </el-row>

        <el-row :span="24" class="zl_module">
          <span class="line">&nbsp;</span>
          <span class="font">{{ tenantName }}</span>
          <span class="line">&nbsp;</span>
        </el-row>
      </el-row>
    </div>

    <!-- <div class="fwdtMenu">

          <span v-for="(item,index) in leftMenu"
                @mousemove="addActive(index)"
                @mouseout="removeActive(index)"
                :class="index==cur ? 'hoverActive':''" @click="openFun(index)">
                <font>{{item.count}}</font>
              {{item.font}}
          </span>
    </div>-->
  </div>
</template>

<script>
import { getUserInfo } from "@/framework/util/auth";
import { RESOURSE_CONFIG, TENANT } from "@/page/config/base_config";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      nowWeek: "",
      nowDate: "", // 今天得日期
      zzts: 0, // 在职天数
      carouselLoading: true,
      shortcutFunctionArr: [],
      FriendLinkArr: [],
      elementGlkzt: "",
      cur: 0,
      leftMenu: [
        {
          font: "待我处理",
          count: 10,
        },
        {
          font: "我已处理",
          count: 10,
        },
        {
          font: "我的申请",
          count: 10,
        },
      ],
      xtdhHide: "",
      glkztHide: "",
      fwlbHide: "",
      current: 0,
      carousel: [
        // {src: 'http://www.wiseloong.com/wp-content/uploads/2018/07/%E9%85%8D%E5%9B%BE.jpg', title: ' 热烈祝贺智隆信息担任重庆现代服务业职业教育集团常务理事单位 '},
        // {src: 'http://www.wiseloong.com/wp-content/uploads/2017/11/15113340841.png', title: '第六届高校智慧校园研讨会暨2017智慧校园三峡论坛' }
      ],
      pageNum: 1,
      pageSize: 6,
      totalPage: 0,
      textConfig: {
        role: "",
      },
      wdsx: "0",
      wdxx: "0",
      iconPath: "/base/images/index/tx.png",
      list: [], // 系统导航
      loadingList: true,
      glkztList: [], // 管理控制台
      loadingglkztList: true,
      lastList: [], // 最新服务
      loadinglastList: true,
      FriendLinkList: [],
      shortcutFunctionList: [],
      operationManual: "",
      myApply: [
        "奖学金申请",
        "学院申请",
        "助学金申请",
        "班主任申请",
        "困难生认定",
        "学工处审核",
      ],
      latestMsg: {
        activeName: "",
        loading: true,
        data: [],
      },
      noticeType: [],
      right_icon_disabled: "",
      left_icon: "",
      carouselHide: "carouselHide",
      // imgList: ['/base/images/index/2.png', '/base/images/index/3.png'],
      imgList: [],
    };
  },

  computed: {
    ...mapGetters(["website"]),
  },

  async mounted() {
    this.getListNoticeType();
    this.judgeRole();
    //   this.getOptionsManual()
    this.getApplyCount();
    this.getDBCount();
    this.getYCLCount();
    this.getKjgnList();
    this.getPhotoNotice();
    await this.searchFwList({ pageNum: this.pageNum, pageSize: this.pageSize });
    await this.getGlkztList({ pageNum: 1, pageSize: 12 });
    await this.getLastList();

    this.getBanner();
    this.addDate();
  },
  created() {
    this.CHANGE_TASKNUM_ASYNC();
  },
  methods: {
    // 获取当前年月日
    addDate() {
      const myDate = new Date();
      const date = {
        year: myDate.getFullYear(),
        month: myDate.getMonth() + 1,
        date: myDate.getDate(),
      };
      const newmonth = date.month > 10 ? date.month : "0" + date.month;
      const day = date.date > 10 ? date.date : "0" + date.date;
      this.nowDate = date.year + "-" + newmonth + "-" + day;
      let wk = myDate.getDay();
      let weeks = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      let week = weeks[wk];
      this.nowWeek = week;
      this.$http
        .get("/personalCenter/getPersonalCenter")
        .then((res) => {
          this.$store.commit("SetGongHao", res.data.id);
          if (
            res.data.subject.accountDetail &&
            res.data.subject.accountDetail.extendInfo
          ) {
            let extendInfo = JSON.parse(
              res.data.subject.accountDetail.extendInfo
            );
            this.dateDiff(extendInfo.hiredDate, this.nowDate);
          }
        })
        .catch((error) => {
          this.$message.error(error.msg);
        });
    },
    dateDiff(d1, d2) {
      this.zzts =
        Math.ceil(
          (new Date(d2).getTime() - new Date(d1).getTime()) /
          1000 /
          60 /
          60 /
          24
        ) + 1;
    },
    ...mapActions(["CHANGE_TASKNUM_ASYNC"]), // 改变任务中心红点

    getGlkztList: async function (params) {
      params.appType = "APP_TYPE_PC";
      params.appKey = RESOURSE_CONFIG.APPLICATION_APPKEY;
      await this.$http
        .post(
          "/syApp/queryScApp",
          {
            entity: { yyfl: "2", sfqy: "1" },
            orderItemList: [
              {
                asc: true,
                column: "sort",
              },
            ],
          },
          { params }
        )
        .then(async (response) => {
          if (response.data.records.length != 0) {
            this.glkztHide = "";
            let that = this;
            let imgSrc = "";

            for (let i = 0; i < response.data.records.length; i++) {
              if (response.data.records[i].icons == null) {
                response.data.records[i].src =
                  "/base/images/index/xt_keyan.png";
              } else {
                response.data.records[i].src =
                  window.config.FDFS_WEB_SERVER_URL +
                  response.data.records[i].icons;
                // await that.$downloadFile
                //   .get("/common/document/download", {
                //     params: {
                //       fileName: "111",
                //       fileUniqueCode: response.data.records[i].icons,
                //       doDownload: false
                //     }
                //   })
                //   .then(res => {
                //     response.data.records[i].src = res.data.url;
                //     return true;
                //   })
                //   .catch(error => {
                //     response.data.records[i].src =
                //       "/base/images/index/xt_keyan.png";
                //     return false;
                //   });
              }
            }
            that.loadingglkztList = false;
            that.glkztList = response.data.records;
          } else {
            this.glkztHide = "glkztHide";
          }
        })
        .catch((error) => {
          this.$message.error(error.msg);
        });
    },

    getLastList: async function () {
      let params = {};
      params.appKey = RESOURSE_CONFIG.APPLICATION_APPKEY;
      params.appType = "APP_TYPE_PC";
      params.pageNum = 1;
      params.pageSize = 8;
      await this.$http
        .post(
          "/syApp/queryScApp",
          {
            entity: { sfqy: "1", yyfl: "1" },
            orderItemList: [
              {
                asc: false,
                column: "createTime",
              },
            ],
          },
          { params }
        )
        .then(async (response) => {
          if (response.data.size != 0) {
            this.lastListHide = "";
            let that = this;
            this.lastList = [];
            let imgSrc = "";
            for (let i = 0; i < response.data.records.length; i++) {
              if (response.data.records[i].icons == null) {
                response.data.records[i].src =
                  "/base/images/index/xt_keyan.png";
              } else {
                response.data.records[i].src =
                  window.config.FDFS_WEB_SERVER_URL +
                  response.data.records[i].icons;
                // await that.$downloadFile
                //   .get("/common/document/download", {
                //     params: {
                //       fileName: "111",
                //       fileUniqueCode: response.data.records[i].icons,
                //       doDownload: false,
                //     },
                //   })
                //   .then((res) => {
                //     response.data.records[i].src = res.data.url;
                //     return true;
                //   })
                //   .catch((error) => {
                //     response.data.records[i].src =
                //       "/base/images/index/xt_keyan.png";
                //     return false;
                //   });
              }
            }
            this.loadinglastList = false;
            this.lastList = response.data.records;
          } else {
            this.lastListHide = "lastListHide";
          }
        })
        .catch((error) => {
          this.$message.error(error.msg);
        });
    },

    getKjgnList: async function () {
      let params = {};
      params.appKey = RESOURSE_CONFIG.APPLICATION_APPKEY;
      params.appType = "APP_TYPE_PC";
      // params.pageNum = 1;
      // params.pageSize = 8;
      this.$http
        .post(
          "/syApp/listScApp",
          {
            entity: { sfqy: "1" },
            orderItemList: [
              {
                asc: false,
                column: "createTime",
              },
            ],
          },
          { params }
        )
        .then(async (response) => {
          response.data.records = response.data;
          if (response.data.records.length != 0) {
            let that = this;
            let imgSrc = "";
            for (let i = 0; i < response.data.records.length; i++) {
              if (response.data.records[i].yyfl == "4") {
                this.FriendLinkArr.push(response.data.records[i]);
              }
              if (response.data.records[i].icons == null) {
                response.data.records[i].src =
                  "/base/images/index/xt_keyan.png";
              } else {
                response.data.records[i].src =
                  window.config.FDFS_WEB_SERVER_URL +
                  response.data.records[i].icons;
                // that.$downloadFile
                //   .get("/common/document/download", {
                //     params: {
                //       fileName: "111",
                //       fileUniqueCode: response.data.records[i].icons,
                //       doDownload: false,
                //     },
                //   })
                //   .then((res) => {
                //     response.data.records[i].src = res.data.url;
                //     return true;
                //   })
                //   .catch((error) => {
                //     response.data.records[i].src =
                //       "/base/images/index/xt_keyan.png";
                //     return false;
                //   });
              }
              if (response.data.records[i].yyfl == "3") {
                this.shortcutFunctionArr.push(response.data.records[i]);
              }
            }
            // that.shortcutFunctionList = response.data.records;
            that.shortcutFunctionList = that.shortcutFunctionArr;
            that.FriendLinkList = that.FriendLinkArr;
          }
        })
        .catch((error) => {
          this.$message.error(error.msg);
        });
    },
    searchFwList: async function (params) {
      params.appKey = RESOURSE_CONFIG.APPLICATION_APPKEY;
      params.appType = "APP_TYPE_PC";
      params.pageSize = 4;
      if (params.pageNum <= 0) {
        this.pageNum = 1;
        return;
      }

      if (this.totalPage / 4 + 1 < params.pageNum) {
        this.pageNum = parseInt(this.totalPage / 4 + 1);
        return;
      }
      params.appType = "APP_TYPE_PC";
      await this.$http
        .post(
          "/syApp/queryScApp",
          {
            entity: { yyfl: "5", sfqy: "1" },
            orderItemList: [
              {
                asc: true,
                column: "sort",
              },
            ],
          },
          { params }
        )
        .then(async (response) => {
          // 如果页面小于4 向右分页置灰
          if (response.data.records.length < 4) {
            this.right_icon_disabled = "right_icon_disabled";
          } else {
            this.right_icon_disabled = "";
          }
          // 当前页面为第一页，向左翻页置灰
          if (response.data.current == 1) {
            this.left_icon = "";
          } else {
            this.left_icon = "left_icon"; // 向左翻页置蓝
          }
          if (response.data.records.length > 0) {
            this.loadingList = true;
            this.xtdhHide = "";
            let that = this;
            this.totalPage = response.data.total;
            this.list = [];
            let imgSrc = "";
            for (let i = 0; i < response.data.records.length; i++) {
              if (response.data.records[i].icons == null) {
                response.data.records[i].src =
                  "/base/images/index/xt_keyan.png";
              } else {
                response.data.records[i].src =
                  window.config.FDFS_WEB_SERVER_URL +
                  response.data.records[i].icons;
                // await that.$downloadFile
                //   .get("/common/document/download", {
                //     params: {
                //       fileName: "111",
                //       fileUniqueCode: response.data.records[i].icons,
                //       doDownload: false,
                //     },
                //   })
                //   .then((res) => {
                //     response.data.records[i].src = res.data.url;
                //     return true;
                //   })
                //   .catch((error) => {
                //     response.data.records[i].src =
                //       "/base/images/index/xt_keyan.png";
                //     return false;
                //   });
              }
            }
            that.loadingList = false;
            that.list = response.data.records;
          } else {
            this.xtdhHide = "xtdhHide";
          }
        })
        .catch((error) => {
          this.$message.error(error.msg);
        });
    },

    nextList: function () {
      this.pageNum = this.pageNum + 1;
      this.searchFwList({ pageNum: this.pageNum, pageSize: this.pageSize });
    },
    prevList: function () {
      this.pageNum = this.pageNum - 1;
      this.searchFwList({ pageNum: this.pageNum, pageSize: this.pageSize });
    },
    goToFWXQ: function (row) {
      // 判断打开方式， 2为新窗体打开
      if (row.dkfs == "2") {
        // 判断是否显示简介， 1跳转到服务详情页面， 直接打开url
        if (row.sfxsjj == "1") {
          let routeData = this.$router.resolve({
            name: "服务详情",
            query: { id: row.id },
          });
          window.open(
            "#" +
            routeData.location.path +
            "?id=" +
            routeData.location.query.id,
            "_blank"
          );
        } else {
          window.open(row.pcUrl, "_blank");
        }
      } else {
        // 判断是否显示简介， 1跳转到服务详情页面， 直接打开url
        if (row.sfxsjj == "1") {
          this.$router.push({ name: "服务详情", query: { id: row.id } });
        } else {
          // 本窗口打开
          window.location.href = row.pcUrl;
          // window.open(row.pcUrl)
        }
      }
    },
    goToFWDT: function () {
      this.$router.push({ name: "服务大厅" });
    },
    goToDB: function () {
      this.$router.push({ name: "我的待办" });
    },
    goToFw: function () {
      this.$router.push({ name: "服务大厅" });
    },

    getApplyCount: function () {
      this.$http
        .get("/flow-ext/my-apply", {
          params: {
            pageNum: 1,
            pageSize: 10,
          },
        })
        .then((response) => {
          if (response.data.total > 99) {
            this.leftMenu[2].count = "99+";
          } else {
            this.leftMenu[2].count = response.data.total;
          }
        })
        .catch((error) => {
          if (error.msg) this.$message.error(error.msg);
          else this.$message.error(error.message);
        });
    },
    getDBCount: function () {
      this.$http
        .get("/flow-ext/my-todo", {
          params: {
            pageNum: 1,
            pageSize: 10,
          },
        })
        .then((response) => {
          if (response.data.total > 99) {
            this.leftMenu[0].count = "99+";
          } else {
            this.leftMenu[0].count = response.data.total;
          }
        })
        .catch((error) => {
          if (error.msg) this.$message.error(error.msg);
          else this.$message.error(error.message);
        });
    },
    getYCLCount: function () {
      this.$http
        .get("/flow-ext/i-did-apply", {
          params: {
            pageNum: 1,
            pageSize: 10,
          },
        })
        .then((response) => {
          if (response.data.total > 99) {
            this.leftMenu[1].count = "99+";
          } else {
            this.leftMenu[1].count = response.data.total;
          }
        })
        .catch((error) => {
          if (error.msg) this.$message.error(error.msg);
          else this.$message.error(error.message);
        });
    },
    openFun: function (index) {
      if (index == 0) {
        this.$router.push({ name: "我的待办" });
      } else if (index == 1) {
        this.$router.push({ name: "我已处理" });
      } else {
        this.$router.push({ name: "我的申请" });
      }
    },
    judgeRole: function () {
      let userInfo = getUserInfo();
      if (userInfo.permissionSubjectId == "wipadmin") {
        this.textConfig.role = "";
      } else {
        this.textConfig.role = "";
      }
    },
    getBanner: function () {
      let userInfo = getUserInfo();

      let params = userInfo.tenantId;
      if (TENANT.isShow) {
        this.$http
          .get("/tenant/" + params)
          .then((response) => {
            //  this.imgList = ['/base/images/index/2.png', '/base/images/index/3.png']
            this.tenantName = response.data.name;
            if (response.data.banner == null || response.data.banner == "") {
              this.imgList = [
                "/base/images/index/banner1.png",
                "/base/images/index/banner2.png",
              ];
            } else {
              this.imgList = response.data.banner.split(",");
            }
          })
          .catch((erro) => {
            return this.$message.error(erro.msg);
          });
      } else {
        this.imgList = [
          "/base/images/index/banner1.png",
          "/base/images/index/banner2.png",
        ];
      }
    },
    getOptionsManual: function () {
      let params = { pageNum: 1, pageSize: 6 };
      this.$http
        .get("/manual/query", {
          params,
        })
        .then((response) => {
          this.operationManual = response.data.records.map(
            (item) => item.moduleName
          );
        })
        .catch((erro) => {
          return this.$message.error(erro.msg);
        });
    },
    getListNoticeType: function () {
      let that = this;
      that.$http
        .post("/notice/list", {
          entity: { status: "1" },
          orderItemList: [
            {
              asc: true,
              column: "id",
            },
          ],
        })
        .then((response) => {
          that.latestMsg.data = response.data;

          that.$http
            .get("/pub/dm-const/listByCataCode", {
              params: { cataCode: "TZLX" },
            })
            .then((response) => {
              let result = [];
              response.data.forEach((element) => {
                that.latestMsg.data.forEach((obj) => {
                  //   console.log(obj)
                  if (element.value == obj.pubtype) {
                    result.forEach((res) => {
                      if (res.value == element.value) {
                        result.pop();
                      }
                    });
                    result.push({
                      label: element.label,
                      value: element.value,
                    });
                  }
                });
              });
              that.noticeType = result;
              // 如果有 加载一条
              if (result && result.length) {
                that.latestMsg.activeName = result[0].value;
                that.handleClick({ name: result[0].value });
              } else {
                this.carouselLoading = false;
              }
            })
            .catch((error) => {
              that.$message.error(error.msg);
            });
        })
        .catch((error) => {
          that.$message.error(error.msg);
        });
    },
    handleClick: function (tab, event) {
      this.$http
        .post(
          "/notice/query",
          {
            entity: {
              pubtype: tab.name,
              status: "1",
            },
            orderItemList: [
              {
                asc: false,
                column: "publish_time",
              },
            ],
          },
          {
            params: {
              pageNum: 1,
              pageSize: 7,
            },
          }
        )
        .then((response) => {
          this.latestMsg.data = response.data.records;
        })
        .catch((error) => {
          this.$message.error(error.msg);
        });
      //   this.carouselLoading = true
      //   this.carouselHide = 'carouselHide'
      //   this.getPhotoNotice(tab.name)
    },
    goToview(content) {
      let routerJump = this.$router.resolve({
        name: "通知公告详情",
        query: { id: content.id },
      });
      window.open(routerJump.href, "_blank");
    },
    goToMore(tabName) {
      let routerJump = this.$router.resolve({
        name: "通知公告列表",
        query: { tabName: tabName },
      });
      window.open(routerJump.href, "_blank");
    },
    addActive(index) {
      this.cur = index;
    },
    removeActive(index) {
      this.cur = index;
    },
    getPhoto(notice) {
      console.log(notice);
      let iconPath = notice.photo;
      let iconTitle = notice.title;
      let id = notice.id;
      if (!iconPath) {
        this.carouselLoading = false;
        this.carouselHide = "";
        this.carousel.push({
          id: notice.id,
          src: "/base/images/index/mr_news.png",
          title: iconTitle,
        });
        return;
      }
      this.carouselLoading = false;
      this.carouselHide = "";
      if (notice.photo != "") {
        this.carousel.push({
          id: notice.id,
          src: window.config.FDFS_WEB_SERVER_URL + notice.photo,
          title: iconTitle,
        });
      }
    },
    getPhotoNotice(pubtype) {
      this.$http
        .post(
          "/notice/query",
          {
            entity: {
              //   pubtype: pubtype,
              status: "1",
            },
            orderItemList: [
              {
                asc: false,
                column: "publish_time",
              },
            ],
          },
          {
            params: {
              pageNum: 1,
              pageSize: 3,
            },
          }
        )
        .then((response) => {
          let dataList = [];
          dataList = response.data.records;
          this.carousel = [];
          let photoList = dataList.map((item) => {
            return this.getPhoto(item);
          });
        })
        .catch((error) => {
          this.$message.error(error.msg);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.avue-main--fullscreen {
  margin-top: 0 !important;
}
//.theme-longyun {
//  ::-webkit-scrollbar {
//    height: 0;
//  }
//}
.avue-main {
  background-color: #f8f8f8;
}
</style>

<style lang="scss" scoped>
#index {
  .cLoading :deep(.el-loading-spinner) {
    margin-top: -188px;
  }
  .el-row {
    width: 100%;
    float: left;
  }
  .title_img {
    width: 520px;
    margin-top: 20px;
  }
  .xtdhHide,
  .fwlbHide,
  .glkztHide,
  .lastListHide,
  .carouselHide {
    display: none;
  }
  font-size: 14px;
  background-color: #eaeaea;
  .system_index {
    max-width: 1680px;
    width: calc(100% - 340px);
    min-width: 1280px;
    height: 100%;
    margin: 0 auto;
    // margin-top: -250px;
    padding-bottom: 20px;
  }
  .zl_module {
    margin-top: 20px;
    .line {
      display: inline-block;
      line-height: 1px;
      border-top: 1px solid #d5d5d5;
      width: 45%;
    }
    .font {
      display: inline-block;
      width: 10%;
      text-align: center;
      color: #a9acba;
      font-size: 12px;
    }
  }

  .index_content {
    margin-top: 15px;
    position: relative;
    .content-card {
      position: absolute;
      z-index: 100;
      width: 20rem;
      top: -190px;
      color: #fff;
      .content-card-top {
        margin-bottom: 20px;
        span {
          .work-day {
            color: orange;
            font-size: 25px;
            padding: 0 2px;
          }
        }
      }
      .content-card-bottom {
        background-color: rgba($color: #fff, $alpha: 0.35);
        height: 90px;
        padding: 15px 15px;
        box-sizing: border-box;
        .el-row {
          & > div {
            height: 60px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          .bottom-left {
          }
          .bottom-center {
            width: 1px;
            background-color: #fff;
            opacity: 0.5;
          }
          .bottom-right {
            padding-left: 10px;
            .richeng {
              ul {
                list-style: none;
                padding-left: 0;
                margin: 0;
                .richeng-bt {
                  padding: 0 2px;
                }
                .richeng-fjx {
                  background-color: #fff;
                  opacity: 0.5;
                  display: inline-block;
                  min-width: 1.5px;
                  height: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
  .banner_bg {
    // background-image: url("/base/images/index/banner-new.png");
    height: 220px;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    width: 100% !important;
    // margin-top: 250px;
  }
  .work_time {
    background-color: rgba(35, 107, 196, 0.5);
    color: white;
    display: inline-block;
    padding: 4px 40px;
    border-radius: 4px;
    float: right;
    margin-top: 22px;
    font-size: 13px;
    margin-bottom: 20px;
  }
  .work_time span {
    color: #fda53b;
    display: inline-block;
    margin-bottom: 4px;
    font-weight: bold;
    font-size: 14px;
    margin-right: 4px;
    margin-left: 4px;
  }
  .dark_gray_font {
    color: #808080;
  }
  .common_part {
    background-color: white;
    border-radius: 10px;
    padding: 12px 34px;
  }
  .common_part.part_1 {
    padding: 15px 34px 40px 34px;
  }
  .shortcut_function {
    margin-top: 0;
  }
  .fast_function {
    width: 95px;
    display: inline-block;
    float: left;
    padding-left: 38px;
    position: relative;
    margin-right: 40px;
    color: #222;
    cursor: pointer;
  }
  .shortcut_function_div {
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
  }
  .shortcut_function_div a img {
    position: absolute;
    left: 0;
    width: 34px;
    top: -5px;
  }
  .shortcut_function_div a p {
    margin-top: 3px;
    margin-bottom: 0;
    padding-left: 5px;
  }
  .carousel_title {
    width: 100%;
    left: 0;
    background-color: #07070766;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    position: absolute;
    bottom: 0;
    color: white;
    text-align: center;
    font-size: 13px;
    font-weight: normal;
    margin: 0;
  }
  .common_title {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px !important;
    margin-top: 20px;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .common_title img {
    vertical-align: text-top;
    margin-right: 3px;
  }
  :deep(.el-col-12 .el-col-24) {
    width: calc(100% - 10px);
    padding-left: 15px;
    padding-right: 15px;
  }
  :deep(.el-tabs__active-bar) {
    background-color: #1871db;
    height: 3px;
  }
  :deep(.is-active) {
    color: black;
    font-weight: bold;
  }
  :deep(.el-tabs__item) {
    font-size: 15px;
    :hover {
      color: #1871db;
    }
  }
  :deep(.el-tabs__nav-scroll) {
    margin-top: 6px;
  }
  :deep(.notice_table td, .notice_table th) {
    border-bottom: 0;
    padding: 6px 0;
    font-size: 14px;
  }
  :deep(.notice_table .cell) {
    padding: 0;
    cursor: pointer;
  }
  :deep(.notice_table .el-table__body-wrapper) {
    overflow-y: hidden;
  }
  :deep(.el-tabs__nav-wrap::after) {
    height: 1px;
  }
  :deep(.el-table::before) {
    height: 0;
  }
  .expressLane_content_xt {
    margin-top: 30px;
    margin-bottom: 15px;
    cursor: pointer;
    padding-left: 30px;
  }
  .expressLane_content_xt p {
    display: inline;
  }
  .expressLane_height {
    height: 120px;
  }
  .expressLane_img {
    width: 54px;
    height: 54px;
    vertical-align: middle;
    margin-right: 10px;
  }
  .left_icon_disabled {
    background-image: url("/base/images/index/page1_disabled.png");
  }
  .right_icon {
    background-image: url("/base/images/index/page2.png");
  }

  .left_icon {
    background-image: url("/base/images/index/page1.png");
  }
  .right_icon_disabled {
    background-image: url("/base/images/index/page2_disabled.png");
  }

  .left_icon,
  .right_icon,
  .left_icon_disabled,
  .right_icon_disabled {
    display: inline-block;
    width: 30px;
    height: 18px;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 20px;
    cursor: pointer;
    float: right;
  }
  .expressLane_content_div {
    padding-bottom: 30px;
    min-height: 140px;
  }
  .pull-right {
    float: right;
  }
  .el-col {
    margin-bottom: 0;
  }
  .seeMore {
    color: #1871db;
    cursor: pointer;
  }
  .todo-item {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 15px;
  }

  :deep(.el-tabs__content) {
    z-index: 999;
  }
  .goToFw {
    float: right;
    // color: #003ed5;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
  }
  .goToFw:hover {
    color: #1871db;
  }
  .fwdtMenu {
    position: fixed;
    top: 50%;
    right: 2%;
    width: 116px;
    background-color: white;
    border-radius: 10px;
    span {
      position: relative;
      color: #4b85e2;
      display: inline-block;
      width: 100%;
      float: left;
      text-align: center;
      padding: 20px 0;
      cursor: pointer;
      border-bottom: 1px solid #c8d0da;
    }
    span:first-child {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    span:last-child {
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
      border-bottom: 0;
    }
    span {
      img {
        vertical-align: middle;
        margin-right: 6px;
        width: 20px;
      }
      font {
        position: absolute;
        width: 15px;
        height: 15px;
        background-color: red;
        border-radius: 100%;
        font-size: 10px;
        right: 15px;
        top: 13px;
        color: white;
      }
    }
    .hoverActive {
      background-color: #4b85e2;
      color: white;
    }
  }
}
</style>
